<div
  *ngIf="stores.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="stores"
    class="sp-width__full">
    <ng-container matColumnDef="store_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <app-shared-id
          [content]="store.store_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="logo">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.LOGO_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <app-shared-store-logo
          size="m"
          [current_store_logo]="store?.store_logo_icon"></app-shared-store-logo>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span
          *ngIf="store.store_name"
          class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ store.store_name?.length > 30 ? (store.store_name | slice : 0 : 30) + '...' : store.store_name }}
        </span>
        <span *ngIf="!store.store_name"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="seller_role">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.ROLE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ store.seller_role }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <div class="sp-row__align">
          <button
            (click)="onSellerDetailClick(store.store_id, store.company_id); $event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"
      class="sp-cursor__pointer"
      (click)="onSellerDetailClick(row.store_id, row.company_id)"></tr>
  </table>
</div>
